<ng-template #template>
  <div class="col-12 p-lg-0">
    <div class="card validate-resp hgs">
      <img class="card-img" src="{{ logoImage }}" alt="" aria-hidden="true" />
      <div class="card-img-overlay align-items-center d-flex">
        <div class="row w-100">
          <div class="col-6 col-md-5 offset-1 offset-md-2">
            <div class="card-title h1-eq" style="line-height: 1">
              This is a test environment. Test decisions cannot be validated.
            </div>
            <div class="card-text h3-eq"></div>
          </div>
          <div class="col-5 col-md-4 offset-md-1 align-items-center d-flex">
            <button
              type="button"
              class="btn btn-validate align-items-center d-flex text-uppercase"
              (click)="onclick()"
              style="color: black"
            >
              Return to team's decision &nbsp;&nbsp;<img
                src="img/arrow-right.svg"
                width="24"
                height="24"
                alt=""
                aria-hidden="true"
            /></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
